export default "__VITE_ASSET__ClsInTiL__"